import 'angular:locale/data:nl-BE';
import 'zone.js';(globalThis.$localize ??= {}).locale = "nl-BE";
